export default __webpack_public_path__ + "static/media/SVG-subcribe2.efb832b2.png";